import Task from './Task'
import merge from '../functions/merge'

export default merge(Task, {
	entity() {
		return merge(Task.entity(), {
			type: 'compound',
			details: {}
		});
	}
});